<template>
  <div class="home-container">
    <VHeader @login="vLoginRefs.show()" />
    <el-row :gutter="20">
      <el-col :xs="24" :sm="16">
        <el-card :header="['活动介绍','Event introduction'][$language]" class="box">
          <div class="summary" v-html="$event.Remark"></div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="8">
        <VSideBar />
      </el-col>
    </el-row>
    <VLogin ref="vLoginRefs" />
  </div>
</template>

<script setup>
  import { ref, inject } from 'vue'

  import VHeader from './header.vue'
  import VSideBar from './sidebar.vue'
  import VLogin from '../../login/index.vue'
  //
  const $event = inject('$event')
  const vLoginRefs = ref(null)
  //
  
  const $language=inject('$language')
</script>

<style lang="scss" scoped>
  .summary {
    :deep() {
      p {
        margin-bottom: 12px;
        font-size: 14px;
        line-height: 24px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
